import Footer from "../components/Footer";
import Hero from "../components/Hero";
import MainPart from "../components/MainPart";
import MainPartv2 from "../components/MainPartv2";
import MainPartv3 from "../components/MainPartv3";
import Navbar from "../components/Navbar";

function Results(){
    return(
        <>
            <Navbar/>
            <Hero
                cName="hero-content" 
                heroImg="https://static.igem.wiki/teams/4696/wiki/hhhero-fig9.jpeg"
                title="Results"
            />
            <div className="content-container">
                <div className="sidepanel">
                    <ul>
                        <a href="#1" className="a-sidepanel"><ul class="header">Macrophage differentiation from reprogrammed iPSC</ul></a>
                        <a href="#1" className="a-sidepanel"><ul class="subheader">iPSC reprogramming from PBMC erythroid progenitor cells</ul></a>
                        <a href="#2" className="a-sidepanel"><ul class="subheader">iPSC Growth Characterization</ul></a>
                        <a href="#3" className="a-sidepanel"><ul class="subheader">iPSC staining</ul></a>
                        <a href="#4" className="a-sidepanel"><ul class="subheader">iPSC CD14+ differentiation</ul></a>
                        <a href="#5" className="a-sidepanel"><ul class="header">Cas9 SIRPa knockout</ul></a>
                        <a href="#6" className="a-sidepanel"><ul class="header">Cloning of the T7-VEE constructs</ul></a>
                        <a href="#6" className="a-sidepanel"><ul class="subheader">Mutagenesis of the T7-VEE</ul></a>
                        <a href="#101" className="a-sidepanel"><ul class="subheader">Sanger Sequencing</ul></a>
                        <a href="#102" className="a-sidepanel"><ul class="subheader">PCR results</ul></a>
                        <a href="#7" className="a-sidepanel"><ul class="header">CAR-IFNγ and Control System Characterization</ul></a>
                    </ul>
                </div>
                
                <MainPartv3
                    section_id={1}
                    container_cName="main-paragraph-container"
                    heading="Macrophage differentiation from reprogrammed iPSC"
                    subheading="iPSC reprogramming from PBMC erythroid progenitor cells"
                    paragraph1={[
                        'The electroporation of Erythroid progenitor cells was done with the Neon Transfection System and the erythroid reprogramming kit with STEMcell technology was utilized for reprogramming. The record of cells under microscope was taken in the following weeks:'
                        
                    ]}
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/res-fig1.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Figure 1: On day 0, some single cells are observed. '
                        ,<br/>,<br/>
                    ]}
                    MainPartImg2='https://static.igem.wiki/teams/4696/wiki/res-fig2.png'
                    img_cName2="MainPartImg"
                    paragraph3={[
                        'Figure 2: After 4-5 days, small colonies start to emerge as round or fibroblast morphology.'
                        ,<br/>,<br/>
                    ]}
                    MainPartImg3='https://static.igem.wiki/teams/4696/wiki/res-fig3.png'
                    img_cName3="MainPartImg"
                    paragraph4={[
                        'Figure 3: After 2-3 weeks, small colonies emerge with compact nucleus to cytoplasm ratio.'
                        
                    ]}
                    img_cName4='hide'
                    paragraph_cName5='hide'
                    img_cName5='hide'
                />
                <MainPartv3
                    section_id={2}
                    container_cName="main-paragraph-container"
                    heading_cName="hide"
                    subheading="iPSC Growth Characterization"
                    paragraph1={[
                        'The iPSC cells were observed daily after thawing. The confluency is measured to determine the appropriate time between passaging '
                        
                    ]}
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/res-fig4.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Figure 4: Post-thaw iPSC cells at day 2. '
                        ,<br/>,<br/>
                    ]}
                    MainPartImg2='https://static.igem.wiki/teams/4696/wiki/res-fig5.png'
                    img_cName2="MainPartImg"
                    paragraph3={[
                        'Figure 5: Post-thaw iPSC cells on day 4.'
                        ,<br/>,<br/>,
                        'High density cell cultures fail to show compact morphology due to the vicinity of cells. Feeding becomes less efficient, cell morphology is affected in order to compensate.'
                        ,<br/>,<br/>,
                    ]}
                    MainPartImg3='https://static.igem.wiki/teams/4696/wiki/res-fig6.png'
                    img_cName3="MainPartImg"
                    paragraph4={[
                        'Figure 6: Post-thaw iPSC cells on day 7.'
                        ,<br/>,<br/>,
                        'The cells at low density are ready to passage. At high density, however, the cell culture exhibited much higher density ideal for passage. Thus, iPSC with high density is recommended to be passed at day 5 after thawing.'
                    ]}
                    img_cName4='hide'
                    paragraph_cName5='hide'
                    img_cName5='hide'
                />
                <MainPartv2
                    section_id={3}
                    container_cName="main-paragraph-container"
                    heading_cName="hide"
                    subheading="iPSC staining"
                    paragraph_cName1="hide"
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/res-fig7.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Figure 7:  OCT4, DAPI and Tra-1-60 staining of iPSC and 293T under 4X dilution.'
                        ,<br/>,<br/>,
                        'The figure is taken with 4X dilution with the same light intensity. The Oct4 stains the nucleus; Tra-1-60 stains the membrane due to different localization of the proteins; and the DAPI visualizes the nuclear DNA in both living and fixed cells.'
                        ,<br/>,<br/>,
                        
                    ]}
                    MainPartImg2='https://static.igem.wiki/teams/4696/wiki/res-fig8.png'
                    img_cName2="MainPartImg"
                    paragraph3={[
                        "Figure 8: OCT4, DAPI and Tra-1-60 staining of iPSC and 293T under 20X dilution"
                        ,<br/>,<br/>,
                        'The figure is taken with 20X dilution with the same light intensity. The Oct4 stains the nucleus; Tra-1-60 stains the membrane due to different localization of the proteins; and the DAPI visualizes the nuclear DNA in both living and fixed cells.'
                        ,<br/>,<br/>,
                        'Figures 7 and 8 both depict immunostaining results. These confirm the identity of the iPSC.'
                        
                    ]}
                    img_cName3="hide"
                />
                <MainPartv3
                    section_id={4}
                    container_cName="main-paragraph-container"
                    heading_cName="hide"
                    subheading="iPSC CD14+ differentiation"
                    paragraph_cName1='hide'
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/res-fig9.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Figure 9: The wild type iPSC cells display compact colony, visible nucleus, and high nucleus to cytoplasm ratio.'
                        ,<br/>,<br/>,
                        'Pictures we got from the differentiation processes:'
                    ]}
                    MainPartImg2='https://static.igem.wiki/teams/4696/wiki/res-fig22.png'
                    img_cName2="MainPartImg"
                    paragraph3={[
                        
                    ]}
                    MainPartImg3='https://static.igem.wiki/teams/4696/wiki/res-fig10.png'
                    img_cName3="MainPartImg"
                    paragraph4={[
                        'Figure 10 & 11: Day 3 of iPSC CD14+ differentiation'
                        ,<br/>,<br/>,
                    ]}
                    MainPartImg4='https://static.igem.wiki/teams/4696/wiki/res-fig11.png'
                    img_cName4="MainPartImg"
                    paragraph_cName5='hide'
                    MainPartImg5='https://static.igem.wiki/teams/4696/wiki/res-fig23.png'
                    img_cName5="MainPartImg"
                />
                <MainPartv3
                    section_id={1000}
                    container_cName="main-paragraph-container"
                    heading_cName="hide"
                    subheading_cName="hide"
                    paragraph1={[
                        'Figure 12 & 13:  Day 5 of iPSC CD14+ differentiation.'
                        ,<br/>,<br/>,
                        'These display colonies incubating in medium B when the cells further differentiate into hematopoietic lineage.'
                        ,<br/>,<br/>,
                    ]}
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/res-fig12.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        
                    ]}
                    MainPartImg2='https://static.igem.wiki/teams/4696/wiki/res-fig13.png'
                    img_cName2="MainPartImg"
                    paragraph3={[
                        'Figure 14 & 15: Day 7 of iPSC CD14+ differentiation'
                        ,<br/>,<br/>,
                        'These pictures show colonies incubating in monocyte differentiation medium.'
                        ,<br/>,<br/>,<br/>,
                        'On day 7 of the differentiation, cell colonies were moved from medium B to monocyte differentiation medium. The colonies are observed to expand bigger and start to exhibit fibroblast-like morphology. On day 14, with an additional 7 days of incubation in monocyte differentiation medium, these progenitor cells start to produce CD14+ monocytes as suspension cells, which can be further differentiated into dendritic cells or monocytes with GM-CSF or m-CSF.'
                    ]}
                    img_cName3="hide"
                    paragraph4={[
                        
                    ]}
                    img_cName4="hide"
                    paragraph_cName5='hide'
                    img_cName5="hide"
                />
                <MainPartv3
                    section_id={5}
                    container_cName="main-paragraph-container"
                    heading="Cas9 SIRPa knockout"
                    subheading_cName="hide"
                    paragraph1='Since the SIRPa-cd47 pathway allows solid tumors to evade targeting by macrophages for phagocytosis. SIRP-a domain is to be knocked out via the Cas9 system. The knockout results are as follows:'
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/res-fig14.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Figure 16:THP-1 after RNP of Thermo Cas9 with srRNA(Cas9 without GFP) under brightfield.'
                        ,<br/>,<br/>,
                        
                    ]}
                    MainPartImg2='https://static.igem.wiki/teams/4696/wiki/res-fig15.png'
                    img_cName2="MainPartImg"
                    paragraph3={[
                        'Figure 17: These figures show THP-1 after RNP of Thermo Cas9 with srRNA under fluorescence. Where the Cas9 is not conjugated with GFP. '
                        ,<br/>,<br/>,
                    ]}
                    MainPartImg3='https://static.igem.wiki/teams/4696/wiki/res-fig16.png'
                    img_cName3="MainPartImg"
                    paragraph4={[
                        'Figure 18: THP-1 after RNP of IDT Cas9-GFP with srRNA (Cas9 with GFP) under brightfield.'
                        ,<br/>,<br/>,
                    ]}
                    MainPartImg4='https://static.igem.wiki/teams/4696/wiki/res-fig17.png'
                    img_cName4="MainPartImg"
                    paragraph5={[
                        'Figure 19: THP-1 after RNP of IDT Cas9-GFP with srRNA (Cas9 with GFP) under fluorescence.'
                        ,<br/>,<br/>,
                        'These figures show THP-1 after RNP of IDT Cas9 with srRNA, where the Cas9 is conjugated with GFP. '
                        ,<br/>,<br/>,<br/>,
                        'It can be concluded that IDT cells had much lower mortality, further a significant proportion of the cells expressed GFP signals indicating successful electroporation of the srRNA vector. The editing efficiency would be further evaluated utilizing flow cytometry.'
                    ]}
                    img_cName5="hide"
                />
                <MainPart
                    section_id={6}
                    container_cName="main-paragraph-container"
                    heading="Cloning of the T7-VEE constructs"
                    subheading='Mutagenesis of the T7-VEE'
                    paragraph={[
                        'The srRNA vector derived from the T7-VEE plasmids allow for replication of the srRNA for a prolonged period of time. Mutations were added to enhance this longevity, allowing for a more powerful and lengthy expression. '
                        ,<br/>,<br/>,
                        'The following primer pairs were used to induce mutation into the Miaoling T7-VEE-GFP plasmids. The mutations were verified via sanger sequencing.'
                        
                    ]}
                    MainPartImg='https://static.igem.wiki/teams/4696/wiki/res-fig25.png'
                    img_cName="MainPartImg"
                />
                <MainPartv3
                    section_id={101}
                    container_cName="main-paragraph-container"
                    heading_cName="hide"
                    subheading="Sanger Sequencing"
                    paragraph1={[
                        
                    ]}
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/res-fig26.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Figure 20: Sanger Sequencing results for Mutation 1'
                        ,<br/>,<br/>,
                    ]}
                    MainPartImg2='https://static.igem.wiki/teams/4696/wiki/res-fig27.png'
                    img_cName2="MainPartImg"
                    paragraph3={[
                        'Figure 21: Sanger Sequencing Results for Mutation 2'
                        ,<br/>,<br/>,
                        
                    ]}
                    MainPartImg3='https://static.igem.wiki/teams/4696/wiki/res-fig28.png'
                    img_cName3="MainPartImg"
                    paragraph4={[
                        'Figure 22: Sanger Sequencing Results for Mutation 3'
                    ]}
                    img_cName4="hide"
                    paragraph_cName5='hide'
                    img_cName5="hide"
                />

                <MainPartv3
                    section_id={102}
                    container_cName="main-paragraph-container"
                    heading_cName='hide'
                    subheading="PCR results: "
                    paragraph1={[
                        
                        
                        'PCR were conducted using the PCR pair noted, using 3 or 4 fragment assembly.The PCR results are as the following, the Ladder used throughout is the NEB 1kb plus DNA ladder.'
                        
                    ]}
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/res-fig18.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Figure 23: PCR result for backbone on agarose gel(PCR1)'
                        ,<br/>,<br/>,
                        
                    ]}
                    MainPartImg2='https://static.igem.wiki/teams/4696/wiki/res-fig19.png'
                    img_cName2="MainPartImg"
                    paragraph3={[
                        'Figure 24: The figure displays the gel result for fragments (PCR from left to right, fragment number 2,3,4,5,6,7).'
                        ,<br/>,<br/>,
                        'The fragments are assembled using NEBuilder DNA HiFi Assembly for 3-4 fragment assembly (1 hour incubation), then transformed into the DH5-alpha competent cells. PCR were conducted.'
                        ,<br/>,<br/>,
                    ]}
                    MainPartImg3='https://static.igem.wiki/teams/4696/wiki/res-fig20.png'
                    img_cName3="MainPartImg"
                    paragraph4={[
                        'Figure 25: The sequence of wells on the gel from left to right is: Ladder, Control (T7-VEE-mut), T7-VEE-CD19-CAR-GFP triplicate, Control (T7-VEE-mut), T7-VEE-Hu9F2-CAR-GFP triplicate.'
                        ,<br/>,<br/>,
                    ]}
                    MainPartImg4='https://static.igem.wiki/teams/4696/wiki/res-fig21.png'
                    img_cName4="MainPartImg"
                    paragraph5={[
                        'Figure 26: The sequence of wells on the gel from left to right is: Control (T7-VEE-mut), T7-VEE-hYP7-CAR-GFP triplicate, Control (T7-VEE-mut), T7-VEE-CD19-CAR-IFN-g triplicate, Ladder, Control (T7-VEE-mut), T7-VEE-Hu9F2-CAR-IFN-g, Control (T7-VEE-mut), T7-VEE-hYP7-CAR-IFN-g triplicate'
                        ,<br/>,<br/>,
                        'The bands are accurately displayed at the corresponding sizes for their respective plasmids. The presence of these bands indicate successful assembly and cloning of the respective plasmids. '
                        ]}
                    img_cName5="hide"
                />
                <MainPart
                    section_id={7}
                    container_cName="main-paragraph-container"
                    heading="CAR-IFNγ and Control System Characterization"
                    subheading_cName='hide'
                    paragraph={[
                        'As of the date of the iGEM 2023 Wiki Freeze, both the CAR-IFNγ and Control System are in the final stages of cloning and cloning verification. These will be characterized in the following weeks and we hope to present these during the Presentation video and at the 2023 Giant Jamboree.'
                        
                    ]}
                    img_cName="hide"
                />
                


            </div>
            <Footer/>
        </>
    )
}

export default Results;